import React from 'react';

const SitePartner = ({ className = "" }) => {
  return (
    <div className={`w-full flex justify-center items-center py-6 px-4 overflow-hidden ${className}`}>
      <div className="w-full max-w-[728px] mx-auto flex justify-center items-center">
        <a 
          href="https://videogen.io?fpr=carol61" 
          target="_blank" 
          rel="noopener noreferrer"
          className="relative block w-full transition-transform duration-300 hover:scale-[1.01] active:scale-[0.99]"
        >
          <img 
            src="https://res.cloudinary.com/dufyzcc72/image/upload/v1773623691/english_one_click_video_creation_728_90_pizi7p.jpg" 
            alt="Feature Highlight" 
            className="w-full h-auto rounded-2xl shadow-2xl border border-slate-200 bg-white"
            style={{ 
              display: 'block', 
              margin: '0 auto',
              minHeight: '60px'
            }}
            loading="eager"
          />
        </a>
      </div>
    </div>
  );
};

export default SitePartner;